import { render, staticRenderFns } from "./EndyaDetail.vue?vue&type=template&id=1b90c123&"
import script from "./EndyaDetail.vue?vue&type=script&lang=js&"
export * from "./EndyaDetail.vue?vue&type=script&lang=js&"
import style0 from "./EndyaDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports